import React from "react"
import PropTypes from "prop-types"
import styled from "react-emotion"
import { withRouter, Link } from "react-router"
import { Icon8 } from "ui"

class SideBarItem extends React.Component {
    render() {
        const url = this.props.url
        const location = window.location.href || ""
        var onThisRoute = location.indexOf(url) !== -1
        if (this.props.exactUrl) {
            onThisRoute = this.props.exactUrl === window.location.pathname
        }
        // const onThisRoute =
        //     this.props.router.routes.filter(
        //         route => route.path === this.props.url || route.parent === this.props.url
        //     ).length > 0
        return (
            <Link to={"/" + this.props.url}>
                <MenuItem light={this.props.light} selected={onThisRoute} color={this.props.color}>
                    {this.props.icon && (
                        <Icon8
                            size={16}
                            color="ffffff"
                            style={this.props.iconStyle}
                            icon={this.props.icon}
                        />
                    )}
                    {this.props.label}
                </MenuItem>
            </Link>
        )
    }
}

SideBarItem.propTypes = {
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
}

const MenuItem = styled("div")`
    color: ${props => (props.light ? "#6a6e84" : "#d0d8e0")};
    padding: ${props => (props.light ? props.theme.small : props.theme.small)} 20px;
    background: ${props => (props.selected ? props => (props.light ? "#E6F0FC" : "#0f4569") : "")};
    border-left: 4px solid
        ${props => (props.selected ? (props.light ? "#009BFF" :
        (props.color === "red" ? "rgb(255, 78, 26)" :
            (props.color === "yellow" ? "rgb(232, 181, 39)" :
                (props.color === "blue" ? "#2980b9" : "")))
    ) : "rgba(0,0,0,0)")};

    font-size: 11pt;
    font-weight: ${props => (props.light ? 300 : 300)};
`

export default withRouter(SideBarItem)

export const SidebarLabel = styled("div")`
    font-size: 15px;

    margin-bottom: 20px;
    margin-top: ${props => (props.light ? props.theme.large : "20px")};
    padding-left: 20px;
    color: ${props => (props.light ? "#393942" : "white")};
    border: none;
    font-family: "Sharp-Sans";
    font-weight: bold;
`



// WEBPACK FOOTER //
// ./src/features/studio/components/SideBarItem.js